// Lightweight password-strength heuristic -- no external library, counts
// length plus character-type variety (lowercase/uppercase/digit/symbol)
// rather than anything more elaborate (e.g. zxcvbn), since a self-contained
// heuristic is consistent with this codebase's existing pure-logic modules
// and avoids a new dependency for what's ultimately a soft UX nudge, not a
// cryptographic guarantee -- Firebase's own 6-character minimum remains the
// actual hard floor, enforced server-side regardless of this score.
//
// Score 0 ("Too Weak") is reserved for anything under Firebase's own
// 6-character minimum, so it reads as "this won't even be accepted," not
// just "this is a bad password" -- those are different signals worth
// keeping visually distinct.
export const PASSWORD_STRENGTH_LEVELS = [
  { label: "Too Weak", color: "#fd874e" },
  { label: "Weak", color: "#fd874e" },
  { label: "Fair", color: "#fcab8b" },
  { label: "Good", color: "#00a274" },
  { label: "Strong", color: "#00a274" }
];

// The minimum score required before the signup form will let the user
// submit -- "Fair" (2) or better. Firebase's bare 6-character minimum alone
// lets through things like "123456" or "password", both of which score
// below this threshold, so this is a real additional gate, not just
// cosmetic feedback.
export const MIN_REQUIRED_PASSWORD_SCORE = 2;

export const getPasswordStrength = (password) => {
  if (!password) return { score: 0, ...PASSWORD_STRENGTH_LEVELS[0] };

  let typeCount = 0;
  if (/[a-z]/.test(password)) typeCount++;
  if (/[A-Z]/.test(password)) typeCount++;
  if (/[0-9]/.test(password)) typeCount++;
  if (/[^A-Za-z0-9]/.test(password)) typeCount++;

  const length = password.length;

  let score;
  if (length < 6) score = 0;
  else if (length < 8 || typeCount < 2) score = 1;
  else if (length < 10 || typeCount < 3) score = 2;
  else if (length < 12 || typeCount < 4) score = 3;
  else score = 4;

  return { score, ...PASSWORD_STRENGTH_LEVELS[score] };
};
